import { Box } from "@qws-org/ui-kit";
import type { FC } from "react";
import React from "react";

import { ArrowGray } from "~/icons";

export const MobileNavigationButtons: FC = () => {
  return (
    <>
      <Box
        className="custom-prev"
        border={{ radius: "4px" }}
        bg="surface-neutral-default"
        position={{
          type: "absolute",
          top: "50%",
          left: "16px",
          zIndex: 10,
        }}
        cursor="pointer"
      >
        <ArrowGray
          viewBox="0 0 32 32"
          width={32}
          height={32}
          className="rotate-180"
        />
      </Box>
      <Box
        border={{ radius: "4px" }}
        bg="surface-neutral-default"
        position={{
          type: "absolute",
          zIndex: 10,
          top: "50%",
          right: "16px",
        }}
        cursor="pointer"
        className="custom-next"
      >
        <ArrowGray viewBox="0 0 32 32" width={32} height={32} />
      </Box>
    </>
  );
};
